import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-17" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-7"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Concluir", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "ss-movimento-comercial-cabecalho-fixo" }
const _hoisted_9 = {
  class: "ant-row ss-movimento-comercial-totalizador ss-sombra-suave",
  style: {"margin-bottom":"10px"}
}
const _hoisted_10 = {
  class: "ant-col ant-col-xs-12 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"padding":"10px 10px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Status", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-1 ss-movimento-comercial-campo-totalizador" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Servicos", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Itens", -1)
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Total dos Servicos", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Total dos Produtos", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Descontos", -1)
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "Frete", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "ant-col ant-col-xs-12 ant-col-xl-2 ss-movimento-comercial-campo-totalizador" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Seguro", -1)
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Outras Despesas", -1)
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "ant-col ant-col-xs-12 ant-col-xl-3 ss-movimento-comercial-campo-totalizador" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", null, "Impostos", -1)
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-4 ss-movimento-comercial-campo-totalizador",
  style: {"background-color":"#000066"}
}
const _hoisted_43 = { style: {"color":"white"} }
const _hoisted_44 = ["value"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("b", null, "Sim", -1)
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-16 ant-col-xl-2" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "ant-col ant-col-xs-8 ant-col-xl-1" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_52 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_53 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_54 = {
  class: "ant-col",
  style: {"flex":"1 0 auto"}
}
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "ant-row" }
const _hoisted_57 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_59 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_60 = { class: "ant-row" }
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_modelo_documento_fiscal = _resolveComponent("selecionar-modelo-documento-fiscal")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_forma_pagamento = _resolveComponent("selecionar-forma-pagamento")!
  const _component_selecionar_marcador_nota_fiscal = _resolveComponent("selecionar-marcador-nota-fiscal")!
  const _component_recebimento_mercadorias_itens = _resolveComponent("recebimento-mercadorias-itens")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_nota_fiscal_servico_itens = _resolveComponent("nota-fiscal-servico-itens")!
  const _component_recebimento_mercadorias_atualizacao_precos = _resolveComponent("recebimento-mercadorias-atualizacao-precos")!
  const _component_nota_fiscal_impostos = _resolveComponent("nota-fiscal-impostos")!
  const _component_nota_fiscal_frete = _resolveComponent("nota-fiscal-frete")!
  const _component_nota_fiscal_descontos_acrescimos = _resolveComponent("nota-fiscal-descontos-acrescimos")!
  const _component_recebimento_mercadorias_busca_financeiro = _resolveComponent("recebimento-mercadorias-busca-financeiro")!
  const _component_recebimento_mercadoria_detalhe_pagamento = _resolveComponent("recebimento-mercadoria-detalhe-pagamento")!
  const _component_nota_fiscal_dados_adicionais = _resolveComponent("nota-fiscal-dados-adicionais")!
  const _component_nota_fiscal_anexos = _resolveComponent("nota-fiscal-anexos")!
  const _component_nota_fiscal_historico = _resolveComponent("nota-fiscal-historico")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_lancamento_rastreabilidade_modal = _resolveComponent("lancamento-rastreabilidade-modal")!
  const _component_validar_pedido_compra_modal = _resolveComponent("validar-pedido-compra-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "100%",
    centered: "",
    maskClosable: false,
    "wrap-class-name": _ctx.state.telaMobile ? 'full-modal ss-modal-compras' : 'scroll-modal ss-modal-compras'
  }, {
    title: _withCtx(() => [
      _createTextVNode("Recebimento de Mercadorias")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      (_ctx.props.operacao.tipoPermissaoDados != _ctx.EPermissaoDados.Visualizar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_a_spin, {
              spinning: _ctx.state.sincronizando,
              tip: "Salvando..."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  ((!_ctx.telaBase.carregando))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        ((_ctx.state.recebimento.codigo > 0))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.state.recebimento.status !== _ctx.EStatusRecebimentoMercadoria.Concluido && _ctx.state.recebimento.status !== _ctx.EStatusRecebimentoMercadoria.Cancelado)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 0,
                                    placement: "top",
                                    title: "Concluir Etapa"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.concluirEtapa && _ctx.concluirEtapa(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "check" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.state.recebimento.status !== _ctx.EStatusRecebimentoMercadoria.EmDigitacao && _ctx.state.recebimento.status !== _ctx.EStatusRecebimentoMercadoria.Concluido && _ctx.state.recebimento.status !== _ctx.EStatusRecebimentoMercadoria.Cancelado)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 1,
                                    placement: "top",
                                    title: "Retornar Etapa"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.retornarEtapa && _ctx.retornarEtapa(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "rollback" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.state.recebimento.status !== _ctx.EStatusRecebimentoMercadoria.Cancelado)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 2,
                                    placement: "top",
                                    title: "Cancelar"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "cancelar" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              ((_ctx.state.recebimento.status === _ctx.EStatusRecebimentoMercadoria.EmDigitacao || _ctx.state.recebimento.status === _ctx.EStatusRecebimentoMercadoria.Cancelado))
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 3,
                                    placement: "top",
                                    title: "Excluir"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.excluir && _ctx.excluir(...args)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "excluir" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_a_tooltip, {
                                placement: "top",
                                title: "Imprimir"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
                                  }, [
                                    _createVNode(_component_icone, { nome: "imprimir" })
                                  ])
                                ]),
                                _: 1
                              }),
                              (_ctx.state.recebimento.status === _ctx.EStatusRecebimentoMercadoria.EmDigitacao)
                                ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                    key: 4,
                                    placement: "top",
                                    title: "Salvar e Novo"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.validarCampos(true)))
                                      }, [
                                        _createVNode(_component_icone, { nome: "adicionar-camada" })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.state.importacaoRecebimentoMercadoria)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validarCampos(false)))
                            }, _hoisted_6))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.validarCampos(false)))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.state.recebimento.codigo > 0 ? 'Salvar' : 'Continuar'), 1)
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["spinning"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          (_ctx.state.recebimento && _ctx.state.recebimento.notaFiscal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input hidden ss-movimento-input-totalizador",
                        style: _normalizeStyle('color: white; font-size: 11px; background-color: ' + _ctx.obterCorStatus(_ctx.state.recebimento.status) + '!important;'),
                        value: _ctx.obterDescricaoStatus(_ctx.state.recebimento.status),
                        disabled: "true"
                      }, null, 12, _hoisted_12)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.state.recebimento.notaFiscal.serie === 'U')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("input", {
                              type: "text",
                              class: "ant-input hidden ss-movimento-input-totalizador",
                              value: _ctx.state.servicos.length,
                              disabled: "true"
                            }, null, 8, _hoisted_16)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("input", {
                              type: "text",
                              class: "ant-input hidden ss-movimento-input-totalizador",
                              value: _ctx.state.recebimento.itens.length,
                              disabled: "true"
                            }, null, 8, _hoisted_19)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.state.recebimento.notaFiscal.serie === 'U')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _hoisted_22,
                            _createElementVNode("input", {
                              type: "text",
                              class: "ant-input hidden ss-movimento-input-totalizador",
                              value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.recebimento.totalServicos, 2, true),
                              disabled: "true"
                            }, null, 8, _hoisted_23)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("input", {
                              type: "text",
                              class: "ant-input hidden ss-movimento-input-totalizador",
                              value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.recebimento.notaFiscal.totalProdutos, 2, true),
                              disabled: "true"
                            }, null, 8, _hoisted_26)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input hidden ss-movimento-input-totalizador",
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.recebimento.notaFiscal.totalDesconto, 2, true),
                        disabled: "true"
                      }, null, 8, _hoisted_29)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input hidden ss-movimento-input-totalizador",
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.recebimento.notaFiscal.totalFrete, 2, true),
                        disabled: "true"
                      }, null, 8, _hoisted_32)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input hidden ss-movimento-input-totalizador",
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.recebimento.notaFiscal.totalSeguro, 2, true),
                        disabled: "true"
                      }, null, 8, _hoisted_35)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input hidden ss-movimento-input-totalizador",
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.recebimento.notaFiscal.totalOutrasDespesas, 2, true),
                        disabled: "true"
                      }, null, 8, _hoisted_38)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input hidden ss-movimento-input-totalizador",
                        value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.valorTotalImpostos, 2, true),
                        disabled: "true"
                      }, null, 8, _hoisted_41)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_a_popover, {
                        placement: "top",
                        title: "Incidência no Total da Nota"
                      }, {
                        content: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.incidenciasCalculo, (incidencia, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: incidencia.incidencia + index,
                              style: {"display":"inline-grid"}
                            }, [
                              (incidencia.incidencia === 'TotalNota')
                                ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                    key: 0,
                                    style: {"margin-left":"0px!important"},
                                    checked: incidencia.valor,
                                    "onUpdate:checked": ($event: any) => ((incidencia.valor) = $event),
                                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.atualizarValoresTotais()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.obtemDescricaoIncidencia(incidencia.identificador)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["checked", "onUpdate:checked"]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_43, [
                            _createTextVNode("Total da Nota "),
                            _createVNode(_component_icone, {
                              class: "ss-icone-informacao-campo",
                              nome: "informacoes-fp"
                            })
                          ]),
                          _createElementVNode("input", {
                            type: "text",
                            class: "ant-input hidden ss-movimento-input-totalizador",
                            style: {"background-color":"#000066","color":"white","font-weight":"bolder"},
                            value: _ctx.UtilitarioMascara.mascararValor(_ctx.state.recebimento.notaFiscal.totalNotaFiscal, 2, true),
                            disabled: "true"
                          }, null, 8, _hoisted_44)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (_ctx.state.editavel && _ctx.state.recuperarSalvamentoAutomatico)
                    ? (_openBlock(), _createBlock(_component_a_alert, {
                        key: 0,
                        type: "warning",
                        "show-icon": "",
                        closable: ""
                      }, {
                        message: _withCtx(() => [
                          _createTextVNode(" Você possui uma versão mais recente deste recebimento salvo de forma automática, deseja recuperar? "),
                          _createVNode(_component_a_button, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.recuperarSalvamentoAutomatico())),
                            size: "small",
                            type: "text"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_45
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_a_form, { layout: "vertical" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, { titulo: "DOCUMENTO FISCAL" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_a_form_item, {
                              label: "Nº da Nota",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  style: {"text-align":"right"},
                                  min: "0",
                                  type: "number",
                                  class: "ant-input ss-recebimento-mercadorias-dados-principais",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.numeroNotaFiscal) = $event)),
                                  disabled: !_ctx.state.editavel,
                                  "on:valorDigitado": _cache[11] || (_cache[11] = ($event: any) => (_ctx.salvamentoAutomatico())),
                                  onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.validarNumeroNota && _ctx.validarNumeroNota(...args))),
                                  onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"]))
                                }, null, 40, _hoisted_48), [
                                  [_vModelText, _ctx.state.recebimento.notaFiscal.numeroNotaFiscal]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_a_form_item, {
                              label: "Série",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input ss-recebimento-mercadorias-dados-principais",
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.serie) = $event)),
                                  disabled: !_ctx.state.editavel,
                                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.salvamentoAutomatico())),
                                  onKeydown: [
                                    _cache[16] || (_cache[16] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                    _cache[17] || (_cache[17] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                  ]
                                }, null, 40, _hoisted_50), [
                                  [_vModelText, _ctx.state.recebimento.notaFiscal.serie]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_a_form_item, {
                              label: "Modelo",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_modelo_documento_fiscal, {
                                  valor: _ctx.state.recebimento.notaFiscal.modelo,
                                  "onUpdate:valor": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.modelo) = $event)),
                                  classCss: "ss-recebimento-mercadorias-dados-principais",
                                  disabled: !_ctx.state.editavel,
                                  onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.salvamentoAutomatico())),
                                  onKeydown: [
                                    _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                    _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","exact"]), ["esc"]))
                                  ]
                                }, null, 8, ["valor", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_a_form_item, {
                              label: "Data de Emissão",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  "hora-minuto-segundo": true,
                                  dataSelecionada: _ctx.state.recebimento.notaFiscal.dataEmissao,
                                  "onUpdate:dataSelecionada": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.dataEmissao) = $event)),
                                  classCss: "ss-recebimento-mercadorias-dados-principais",
                                  disabled: !_ctx.state.editavel,
                                  onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.salvamentoAutomatico())),
                                  onKeydown: [
                                    _cache[24] || (_cache[24] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                    _cache[25] || (_cache[25] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","exact"]), ["esc"]))
                                  ]
                                }, null, 8, ["dataSelecionada", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_a_form_item, {
                              label: "Data de Entrada",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_data, {
                                  "hora-minuto-segundo": true,
                                  dataSelecionada: _ctx.state.recebimento.notaFiscal.dataEntradaSaida,
                                  "onUpdate:dataSelecionada": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.dataEntradaSaida) = $event)),
                                  classCss: "ss-recebimento-mercadorias-dados-principais",
                                  disabled: !_ctx.state.editavel,
                                  onChange: _cache[27] || (_cache[27] = ($event: any) => (_ctx.salvamentoAutomatico())),
                                  onKeydown: [
                                    _cache[28] || (_cache[28] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                    _cache[29] || (_cache[29] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent","exact"]), ["esc"]))
                                  ]
                                }, null, 8, ["dataSelecionada", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_a_form_item, {
                              label: "Chave de Acesso",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input ss-recebimento-mercadorias-dados-principais",
                                  maxlength: "44",
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.chaveAcesso) = $event)),
                                  disabled: !_ctx.state.editavel,
                                  onKeyup: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.atualizarChaveAcesso && _ctx.atualizarChaveAcesso(...args))),
                                  onKeydown: [
                                    _cache[32] || (_cache[32] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                    _cache[33] || (_cache[33] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                  ]
                                }, null, 40, _hoisted_55), [
                                  [_vModelText, _ctx.state.recebimento.notaFiscal.chaveAcesso]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_a_form_item, {
                              label: "Emitente/Fornecedor",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_pessoa, {
                                  empresas: [_ctx.state.recebimento.codigoEmpresa],
                                  recursoOrigem: "RECEBIMENTOS_MERCADORIAS",
                                  classCss: "ss-recebimento-mercadorias-dados-principais",
                                  codigoSelecionado: _ctx.state.recebimento.notaFiscal.emitente.codigoPessoa,
                                  "onUpdate:codigoSelecionado": [
                                    _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.emitente.codigoPessoa) = $event)),
                                    _ctx.obterEstoquesDisponiveis
                                  ],
                                  "tipo-relacao": _ctx.ETipoRelacaoPessoa.Fornecedor,
                                  disabled: !_ctx.state.editavel,
                                  onKeydown: [
                                    _cache[35] || (_cache[35] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                    _cache[36] || (_cache[36] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                  ]
                                }, null, 8, ["empresas", "codigoSelecionado", "tipo-relacao", "disabled", "onUpdate:codigoSelecionado"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo de Operação",
                              class: "ss-margin-campos",
                              rules: [{ required: true }]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_operacao, {
                                  codigoSelecionado: _ctx.state.recebimento.codigoTipoOperacao,
                                  "onUpdate:codigoSelecionado": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.recebimento.codigoTipoOperacao) = $event)),
                                  tipoMovimento: _ctx.ETipoMovimentoComercial.Compras,
                                  empresas: [_ctx.state.recebimento.codigoEmpresa],
                                  onChange: _cache[38] || (_cache[38] = ($event: any) => (_ctx.preencherTipoOperacao(true))),
                                  disabled: !_ctx.state.editavel
                                }, null, 8, ["codigoSelecionado", "tipoMovimento", "empresas", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_selecionar_forma_pagamento, {
                              apresentacaoPersonalizada: true,
                              classCss: "ss-recebimento-mercadorias-dados-principais",
                              empresas: [_ctx.state.recebimento.codigoEmpresa],
                              codigoSelecionado: _ctx.state.recebimento.codigoFormaPagamento,
                              "onUpdate:codigoSelecionado": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.recebimento.codigoFormaPagamento) = $event)),
                              "tipo-movimento": _ctx.ETipoMovimentoComercial.Compras,
                              required: true,
                              disabled: !_ctx.state.editavel,
                              onChange: _ctx.atualizarFormaPagamento,
                              onKeydown: [
                                _cache[40] || (_cache[40] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                _cache[41] || (_cache[41] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                              ]
                            }, null, 8, ["empresas", "codigoSelecionado", "tipo-movimento", "disabled", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_component_a_form_item, {
                              label: "Marcadores",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_marcador_nota_fiscal, {
                                  marcadoresSelecionados: _ctx.state.marcadores,
                                  "onUpdate:marcadoresSelecionados": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.state.marcadores) = $event)),
                                  onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.salvamentoAutomatico())),
                                  disabled: !_ctx.state.editavel,
                                  onKeydown: _cache[44] || (_cache[44] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["esc"]))
                                }, null, 8, ["marcadoresSelecionados", "disabled"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        (_ctx.state.recebimento.codigo > 0 || _ctx.state.importacaoRecebimentoMercadoria || _ctx.state.importandoPedidoCompra)
                          ? (_openBlock(), _createBlock(_component_a_tabs, {
                              key: 0,
                              defaultActiveKey: "1"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.state.recebimento.notaFiscal.serie !== 'U')
                                  ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                      key: "1",
                                      tab: "ITENS"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_spin, {
                                          spinning: _ctx.state.sincronizandoItem
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_component_recebimento_mercadorias_itens, {
                                              empresa: _ctx.state.recebimento.codigoEmpresa,
                                              pessoa: _ctx.state.recebimento.notaFiscal.emitente.codigoPessoa,
                                              cfop: _ctx.state.cfopSelecionado,
                                              movimentarEstoque: _ctx.state.tipoOperacao.movimentarEstoque,
                                              estoquesDisponiveis: _ctx.state.estoquesDisponiveis,
                                              totalNota: _ctx.state.recebimento.notaFiscal.totalNotaFiscal,
                                              itens: _ctx.state.recebimento.itens,
                                              tiposCustosCadastrados: _ctx.state.tiposCustosCadastrados,
                                              editavel: _ctx.state.editavel,
                                              onAtualizarItem: _ctx.atualizarItem,
                                              onExcluirItem: _ctx.excluirItem,
                                              novoItem: _ctx.state.novoItem,
                                              "onUpdate:novoItem": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.state.novoItem) = $event)),
                                              carregandoItensPelaImportacao: _ctx.state.carregandoItensPelaImportacao,
                                              "onUpdate:carregandoItensPelaImportacao": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.state.carregandoItensPelaImportacao) = $event)),
                                              key: _ctx.state.chaveItens
                                            }, null, 8, ["empresa", "pessoa", "cfop", "movimentarEstoque", "estoquesDisponiveis", "totalNota", "itens", "tiposCustosCadastrados", "editavel", "onAtualizarItem", "onExcluirItem", "novoItem", "carregandoItensPelaImportacao"]))
                                          ]),
                                          _: 1
                                        }, 8, ["spinning"])
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_a_tab_pane, {
                                      key: "2",
                                      tab: "ITENS"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_spin, {
                                          spinning: _ctx.state.sincronizandoItem
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_nota_fiscal_servico_itens, {
                                              regimeTributario: _ctx.state.regimeTributario,
                                              empresa: _ctx.state.recebimento.codigoEmpresa,
                                              "obrigar-principal": false,
                                              editavel: _ctx.state.editavel,
                                              itens: _ctx.state.servicos,
                                              "onUpdate:itens": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.state.servicos) = $event)),
                                              onExcluirItem: _ctx.excluirServico,
                                              onAtualizarValores: _ctx.atualizarValoresTotais,
                                              entrada: true
                                            }, null, 8, ["regimeTributario", "empresa", "editavel", "itens", "onExcluirItem", "onAtualizarValores"])
                                          ]),
                                          _: 1
                                        }, 8, ["spinning"])
                                      ]),
                                      _: 1
                                    })),
                                ((_ctx.state.recebimento.itens.length > 0))
                                  ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                                      key: "2",
                                      tab: "ATUALIZAÇÃO PREÇOS"
                                    }, {
                                      default: _withCtx(() => [
                                        (!_ctx.state.sincronizandoItem)
                                          ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_atualizacao_precos, {
                                              key: 0,
                                              empresa: _ctx.state.recebimento.codigoEmpresa,
                                              itens: _ctx.state.recebimento.itens,
                                              tiposCustosCadastrados: _ctx.state.tiposCustosCadastrados,
                                              editavel: _ctx.state.editavel
                                            }, null, 8, ["empresa", "itens", "tiposCustosCadastrados", "editavel"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_a_tab_pane, {
                                  key: "3",
                                  tab: "IMPOSTOS"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_nota_fiscal_impostos, {
                                      impostos: _ctx.state.recebimento.notaFiscal.totalImpostos,
                                      "onUpdate:impostos": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.totalImpostos) = $event)),
                                      incidenciasCalculo: _ctx.state.incidenciasCalculo,
                                      "onUpdate:incidenciasCalculo": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.state.incidenciasCalculo) = $event)),
                                      onTotalAlterado: _ctx.atualizarValoresTotais,
                                      editavel: false
                                    }, null, 8, ["impostos", "incidenciasCalculo", "onTotalAlterado"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_tab_pane, {
                                  key: "4",
                                  tab: "FRETE"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_nota_fiscal_frete, {
                                      notaFiscal: _ctx.state.recebimento.notaFiscal,
                                      "onUpdate:notaFiscal": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.state.recebimento.notaFiscal) = $event)),
                                      editavel: _ctx.state.editavel,
                                      mostrarOutrosValores: false,
                                      onTotalAlterado: _ctx.atualizarValoresTotais
                                    }, null, 8, ["notaFiscal", "editavel", "onTotalAlterado"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_tab_pane, {
                                  key: "5",
                                  tab: "DESCONTOS E ACRÉSCIMOS"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_nota_fiscal_descontos_acrescimos, {
                                      notaFiscal: _ctx.state.recebimento.notaFiscal,
                                      "onUpdate:notaFiscal": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.state.recebimento.notaFiscal) = $event)),
                                      editavel: _ctx.state.editavel,
                                      onTotalAlterado: _ctx.atualizarValoresTotais,
                                      onDescontoAlterado: _ctx.atualizarDescontoGeral
                                    }, null, 8, ["notaFiscal", "editavel", "onTotalAlterado", "onDescontoAlterado"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_tab_pane, {
                                  key: "6",
                                  tab: "DETALHES DO PAGAMENTO"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_recebimento_mercadoria_detalhe_pagamento, {
                                      empresa: _ctx.state.recebimento.codigoEmpresa,
                                      tiposDocumentos: _ctx.state.tipoDocumentos,
                                      totalDetalhesPagamento: _ctx.state.totalDetalhesPagamento,
                                      "onUpdate:totalDetalhesPagamento": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.state.totalDetalhesPagamento) = $event)),
                                      recebimento: _ctx.state.recebimento,
                                      "onUpdate:recebimento": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.state.recebimento) = $event)),
                                      detalhesPagamento: _ctx.state.recebimento.notaFiscal.detalhesPagamento,
                                      "onUpdate:detalhesPagamento": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.detalhesPagamento) = $event)),
                                      editavel: _ctx.state.editavel,
                                      onAtualizarDetalhePagamento: _ctx.atualizarDetalhePagamento
                                    }, {
                                      RecursoExtra: _withCtx(() => [
                                        _createElementVNode("button", {
                                          class: "ant-btn ant-btn-secondary ss-tamanho-completo ss-acao-destaque-secundaria",
                                          onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.apresentarBuscarVincularTitulos && _ctx.apresentarBuscarVincularTitulos(...args)))
                                        }, "Buscar/Vincular títulos já lançados"),
                                        (_ctx.state.apresentarBuscaFinanceiro && _ctx.state.editavel)
                                          ? (_openBlock(), _createBlock(_component_recebimento_mercadorias_busca_financeiro, {
                                              key: 0,
                                              empresa: _ctx.state.recebimento.codigoEmpresa,
                                              editavel: _ctx.state.editavel,
                                              codigoPessoa: _ctx.state.recebimento.notaFiscal.emitente.codigoPessoa,
                                              detalhesPagamento: _ctx.state.recebimento.notaFiscal.detalhesPagamento,
                                              "onUpdate:detalhesPagamento": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.detalhesPagamento) = $event)),
                                              totalNotaFiscal: _ctx.state.recebimento.notaFiscal.totalNotaFiscal
                                            }, null, 8, ["empresa", "editavel", "codigoPessoa", "detalhesPagamento", "totalNotaFiscal"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["empresa", "tiposDocumentos", "totalDetalhesPagamento", "recebimento", "detalhesPagamento", "editavel", "onAtualizarDetalhePagamento"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_tab_pane, {
                                  key: "7",
                                  tab: "DADOS ADICIONAIS"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_nota_fiscal_dados_adicionais, {
                                      notaFiscal: _ctx.state.recebimento.notaFiscal,
                                      "onUpdate:notaFiscal": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.state.recebimento.notaFiscal) = $event)),
                                      editavel: _ctx.state.editavel,
                                      onCampoAlterado: _cache[58] || (_cache[58] = ($event: any) => (_ctx.salvamentoAutomatico()))
                                    }, null, 8, ["notaFiscal", "editavel"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_tab_pane, {
                                  key: "8",
                                  tab: "ANEXOS"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_nota_fiscal_anexos, {
                                      codigoRegistro: _ctx.state.recebimento.notaFiscal.codigo,
                                      empresa: _ctx.state.recebimento.codigoEmpresa,
                                      editavel: _ctx.state.editavel,
                                      anexos: _ctx.state.recebimento.notaFiscal.anexos,
                                      "onUpdate:anexos": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.state.recebimento.notaFiscal.anexos) = $event)),
                                      onAtualizarAnexo: _ctx.atualizarAnexo,
                                      onExcluirAnexo: _ctx.excluirAnexo
                                    }, null, 8, ["codigoRegistro", "empresa", "editavel", "anexos", "onAtualizarAnexo", "onExcluirAnexo"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_tab_pane, {
                                  key: "9",
                                  tab: "HISTÓRICO"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_nota_fiscal_historico, {
                                      registros: _ctx.state.registrosAtividade
                                    }, null, 8, ["registros"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_lancamento_rastreabilidade_modal, {
        empresa: _ctx.state.recebimento.codigoEmpresa,
        visivel: _ctx.state.lancarRastreabilidade,
        "onUpdate:visivel": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.state.lancarRastreabilidade) = $event)),
        lancouRastreabilidade: _ctx.state.lancouRastreabilidade,
        "onUpdate:lancouRastreabilidade": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.state.lancouRastreabilidade) = $event)),
        codigoDefinicaoProduto: _ctx.state.codigoProdutoSelecionado,
        itemEstoque: _ctx.state.codigoItemEstoqueSelecionado,
        recurso: 'RECEBIMENTOS_MERCADORIAS',
        quantidade: _ctx.state.quantiddadeSelecionado,
        codigoOperacao: _ctx.state.codigoItemSelecionado,
        rastreabilidades: _ctx.state.rastreabilidades,
        "onUpdate:rastreabilidades": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.state.rastreabilidades) = $event)),
        codigoTipoOperacao: _ctx.state.numeroNotaSelecionado
      }, null, 8, ["empresa", "visivel", "lancouRastreabilidade", "codigoDefinicaoProduto", "itemEstoque", "quantidade", "codigoOperacao", "rastreabilidades", "codigoTipoOperacao"]),
      _createVNode(_component_validar_pedido_compra_modal, {
        empresa: _ctx.state.recebimento.codigoEmpresa,
        visivel: _ctx.state.exibirValidacaoPedido,
        "onUpdate:visivel": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.state.exibirValidacaoPedido) = $event)),
        pedidos: _ctx.state.pedidosCompra,
        codigosSelecionados: _ctx.state.pedidosSelecionados,
        "onUpdate:codigosSelecionados": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.state.pedidosSelecionados) = $event)),
        produtos: _ctx.state.produtosPedidos,
        onConfirmacao: _ctx.marcarPedidosCompra
      }, null, 8, ["empresa", "visivel", "pedidos", "codigosSelecionados", "produtos", "onConfirmacao"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}